import React from "react";
import parse from "html-react-parser";

const Raw = ({ html, replace }) => {
    return (
        <div className="raw">
            {parse(html, {
                replace: domNode => {
                    if (replace[domNode.name]) {
                        return replace[domNode.name](domNode);
                    }
                },
            })}
        </div>
    );
};

export default Raw;
